import { useState } from 'react';
import { api, ErrorApi } from '../api';

/**
 * Solicitud de enlace de recuperación.
 *
 * El mensaje de confirmación es deliberadamente ambiguo —"si el correo
 * corresponde a una cuenta"— y no cambia según exista o no. Una pantalla que
 * dijera "no encontramos ese correo" convertiría el formulario en un
 * verificador de qué personas tienen cuenta.
 */
export function Recuperar({ onVolver }: { onVolver: () => void }) {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: React.FormEvent): Promise<void> {
    evento.preventDefault();
    if (!email.trim()) return;

    setEnviando(true);
    setError(null);
    try {
      await api.recuperar(email.trim());
      setEnviado(true);
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'no se pudo contactar el portal');
    } finally {
      setEnviando(false);
    }
  }

  if (enviado) {
    return (
      <div className="acceso">
        <h1>Revisa tu correo</h1>
        <p>
          Si el correo corresponde a una cuenta, te enviamos un enlace para restablecer la
          contraseña. Es válido por 30 minutos y se puede usar una sola vez.
        </p>
        <button className="secundario" onClick={onVolver}>
          Volver al acceso
        </button>
      </div>
    );
  }

  return (
    <div className="acceso">
      <h1>Recuperar contraseña</h1>
      <p>Te enviamos un enlace para elegir una nueva.</p>

      <form onSubmit={(e) => void enviar(e)}>
        <label>
          <span>Correo</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <button type="submit" disabled={enviando}>
          {enviando ? 'Enviando…' : 'Enviar enlace'}
        </button>
      </form>

      {error && <p className="error">{error}</p>}

      <button className="enlace bajo" onClick={onVolver}>
        Volver al acceso
      </button>
    </div>
  );
}
